import { HStack } from "@/components/ui/hstack";
import { Input, InputField } from "@/components/ui/input";
import { Text } from "@/components/ui/text";
import {
    Button,
    ButtonIcon, ButtonText,
} from "@/components/ui/button";
import {
    Popover,
    PopoverBackdrop,
    PopoverContent,
} from "@/components/ui/popover";
import {MaterialCommunityIcons} from "@expo/vector-icons";
import {useEffect, useState} from "react";


export default function NumberOfStepsButton({ filterValue, setFilterValue=(value)=>{}, onDelete=()=>{}, openOnMount=false }) {

    const [isOpen, setIsOpen] = useState(false)
    const [value, setValue] = useState(null)

    useEffect(() => {
        setIsOpen(openOnMount)
    }, [])

    useEffect(() => {
        setValue(filterValue ?? {minimum: 0, maximum: 0})
    }, [filterValue])

    return (
        <Popover
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            onOpen={() => setIsOpen(true)}
            placement='top left'
            offset={10}
            trigger={({ ...triggerProps }) => (
                <Button
                    {...triggerProps}
                    size="sm"
                    className={`group w-9 h-9 rounded-full items-center justify-center bg-transparent border border-primary-900
                    overflow-hidden ${filterValue ? 'bg-primary-900' : 'bg-transparent'}`}
                >
                    <ButtonIcon
                        as={MaterialCommunityIcons}
                        name="foot-print"
                        size={18}
                        className={`${filterValue ? 'text-white' : 'text-primary-900'} group-hover:text-white`}
                    />
                </Button>
            )}
        >
            <PopoverBackdrop className='bg-transparent' />
            <PopoverContent className="bg-white p-3.5 w-auto rounded-md shadow-md flex flex-col gap-3">
                <Text className="font-semibold">Anzahl Schritte</Text>

                <HStack className="flex-row items-center justify-between gap-5">
                    <Text>Minimum</Text>
                    <Input className="w-[100px] border border-gray-300 rounded-md">
                        <InputField
                            className="px-2 py-1.5 text-sm"
                            value={value?.minimum}
                            onChangeText={text => {
                                try {
                                    const number = Number.parseInt(text, 10);
                                    setValue({
                                        ...value,
                                        minimum: isNaN(number) ? 0 : number,
                                    });
                                } catch {}
                            }}
                        />
                    </Input>
                </HStack>

                <HStack className="flex-row items-center justify-between gap-5">
                    <Text>Maximum</Text>
                    <Input className="w-[100px] border border-gray-300 rounded-md">
                        <InputField
                            className="px-2 py-1.5 text-sm"
                            value={value?.maximum}
                            onChangeText={text => {
                                try {
                                    const number = Number.parseInt(text, 10);
                                    setValue({
                                        ...value,
                                        maximum: isNaN(number) ? 0 : number,
                                    });
                                } catch {}
                            }}
                        />
                    </Input>
                </HStack>

                <HStack className="flex-row justify-between gap-2">
                    <Button
                        className="flex-1 h-[34px] bg-primary-900 px-7"
                        onPress={() => {
                            setFilterValue(value);
                            setIsOpen(false);
                        }}
                    >
                        <ButtonText className="text-white">Auswählen</ButtonText>
                    </Button>

                    <Button
                        className="h-[34px] bg-error-600 px-3"
                        onPress={onDelete}
                    >
                        <ButtonIcon
                            as={MaterialCommunityIcons}
                            name="trash-can"
                            className="text-white"
                            size={18}
                        />
                    </Button>
                </HStack>
            </PopoverContent>
        </Popover>
    )

}
